<template>
  <div>
    <k-autocomplete
    :items="notifiers_list"
    v-model="val"
    label="Notifiers"
    item-value="name"
    item-text="name"
    return-object
    multiple>
    </k-autocomplete>

    <div v-for="notifier in val" :key="notifier.id" v-if="get_form(notifier.id).length > 0 && show_form">
      <div class="pb-1">{{notifier.name}}</div>
      <div>
        <component v-for="elem in get_form(notifier.id)" :key="elem.name" v-bind:is="elem.type" v-bind="elem" v-model="notifier.form_data">
          <k-layout>
            <k-flex :cols="row_classes(elem.childs)" v-for="celem in elem.childs" :key="celem.key">
              <component v-bind:is="celem.type" v-bind="celem" v-model="notifier.form_data"></component>
            </k-flex>
          </k-layout>
        </component>
      </div>
    </div>
  </div>
</template>

<script>
import SettingsModel from '@/models/settings.js'
import ChannelModel from '@/models/channel.js'
import * as FormItems from '@/components/form_items'

export default {
  props: {
    value: Array,
    show_form: {
      type: Boolean,
      default: true
    }
  },
  components: {
    ...FormItems
  },
  methods: {
    row_classes(childs) {
      return Math.round(12/childs.length);
    },
    get_form(id) {
      return _.get(_.find(this.notifiers, (notifier) => { return notifier.id == id; }), "value.form", []);
    }
  },
  computed: {
    val: {
      get() {
        return this.value || []
      },
      set(val) {
        this.$emit("input", val);
      }
    },
    notifiers() {
      return ChannelModel.notifiers()
    },
    notifiers_list() {
      return _.map(this.notifiers, (notifier) => { return {id: notifier.id, name: notifier.name, form_data: {}} });
    }
  }
}
</script>
